export const navLinks = [
    {
        display: 'Home',
        url: '/',
    },
    {
        display: 'Menu',
        url: 'menu',
    },
    {
        display: 'Recipe',
        url: 'recipe',
    },
    {
        display: 'About',
        url: 'about',
    },
    {
        display: 'Contact',
        url: 'contact',
    },
];
